const formDataSchema ={
    feilds: [
        {
            id: 1,
            name: 'doctorid',
            text: 'Consultant Name',
            visible: true,
            element: 'select2',
            required: true,
            input_type: 'select',
            placeholder: 'Consultant Name',
            icon: 'user',
            rules: [
                // {
                //     test: (value) => {
                //         return (value !== null && value.length > 0);
                //         return true;
                //     },
                //     message: 'Consultant Name'
                // }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: false,
            className: 'col'
        }, {
            id: 2,
            name: 'payment_type',
            text: 'Payment Type',
            visible: true,
            element: 'select2',
            required: true,
            input_type: 'select',
            placeholder: 'Select',
            icon: 'user',
            rules: [
                {
                    // test: (value) => {
                    //     return (value !== null && value.length > 0);
                    //     return true;
                    // },
                    // message: 'Gender'
                }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: false,
            className: 'col'
        },{
            id: 3,
            name: 'search',
            text: 'Counsellor',
            visible: true,
            element: 'input',
            required: true,
            input_type: 'input',
            placeholder: 'Counsellor Name',
            icon: 'user',
            rules: [
                {
                    // test: (value) => {
                    //     return (value !== null && value.length > 0);
                    // },
                    // message: 'Please Select Your Appointment Date'
                }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: false,
            className: 'col-12 d-flex pr-0'
        },{
            id: 4,
            name: 'date',
            text: 'Date',
            visible: true,
            element: 'daterange',
            required: true,
            input_type: 'date',
            placeholder: 'Select Date',
            icon: 'user',
            rules: [
                // {
                //     test: (value) => {
                //         return (value !== null && value.length > 0);
                //     },
                //     message: 'Please Select  Date'
                // }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: false,
            className: 'col-4 d-flex pr-0 float-right'
        },{
            id: 1,
            name: 'search',
            text: 'IP or UMR No:',
            visible: true,
            element: 'inputSearch',
            required: true,
            input_type: 'input',
            placeholder: 'Patient Name or UMR or IP',
            icon: 'user',
            rules: [
                {
                    // test: (value) => {
                    //     return (value !== null && value.length > 0);
                    // },
                    // message: 'Please Select Your Appointment Date'
                }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: false,
            className: 'col-12 d-flex pr-0'
        }
    ]
}

export default formDataSchema;